import React, { useEffect } from 'react';
import { useSettings } from '../context/SettingsContext';

const Privacy = () => {
    const { settings } = useSettings();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div style={{ paddingTop: '100px', paddingBottom: '60px', background: 'var(--color-cream)', minHeight: '100vh' }}>
            <div className="container" style={{ maxWidth: '800px', background: 'white', padding: '40px', borderRadius: '8px', boxShadow: '0 4px 20px rgba(0,0,0,0.05)' }}>
                <h1 style={{ color: 'var(--color-brown)', marginBottom: '30px', borderBottom: '2px solid var(--color-gold)', paddingBottom: '10px' }}>Politique de Confidentialité</h1>

                <p>Mise à jour le {new Date().toLocaleDateString('fr-FR')}</p>

                <section style={{ marginTop: '30px' }}>
                    <h2 style={{ color: 'var(--color-brown)', fontSize: '1.4rem' }}>Introduction</h2>
                    <p>
                        Chez <strong>{settings.siteName}</strong>, nous accordons une importance fondamentale à la confidentialité de nos clients.
                        La présente politique documente notre approche concernant la collecte, le traitement et la protection de vos données personnelles lors de l'utilisation de notre site internet et de nos services en boutique (Click & Collect, compte de fidélité...).
                    </p>
                </section>

                <section style={{ marginTop: '30px' }}>
                    <h2 style={{ color: 'var(--color-brown)', fontSize: '1.4rem' }}>Données recueillies</h2>
                    <p>
                        Nous sommes amenés à collecter les données suivantes lorsque vous passez commande, lorsque vous créez un compte ou lorsque vous nous contactez :
                    </p>
                    <ul style={{ marginLeft: '20px', margin: '15px 0', lineHeight: '1.6' }}>
                        <li><strong>Identité :</strong> Nom, prénom</li>
                        <li><strong>Contact :</strong> Adresse e-mail, numéro de téléphone</li>
                        <li><strong>Commandes :</strong> Historique de vos achats, liste des favoris, données liées au paiement.</li>
                    </ul>
                </section>

                <section style={{ marginTop: '30px' }}>
                    <h2 style={{ color: 'var(--color-brown)', fontSize: '1.4rem' }}>Utilisation des données</h2>
                    <p>Vos données sont exclusivement utilisées pour :</p>
                    <ul style={{ marginLeft: '20px', margin: '15px 0', lineHeight: '1.6' }}>
                        <li>Le traitement de vos commandes en ligne</li>
                        <li>L'envoi de confirmations et de notifications liées à votre retrait (Click & Collect)</li>
                        <li>Répondre à vos potentielles questions et requêtes</li>
                        <li>Améliorer nos services et la sécurité du site.</li>
                    </ul>
                    <p>Nous nous engageons de manière stricte : <strong>aucune donnée personnelle n'est vendue, cédée, ou échangée avec des tiers</strong> à l'exception de nos prestataires techniques (hébergement, traitement des paiements sécurisés) agissant sous notre stricte autorité.</p>
                </section>

                <section style={{ marginTop: '30px' }}>
                    <h2 style={{ color: 'var(--color-brown)', fontSize: '1.4rem' }}>Sécurité</h2>
                    <p>
                        Nous mettons en place des mesures de sécurité organisationnelles et logicielles pour préserver l'intégrité de vos données, tout particulièrement lors du processus de paiement et de l'authentification (mots de passe chiffrés).
                    </p>
                </section>

                <section style={{ marginTop: '30px' }}>
                    <h2 style={{ color: 'var(--color-brown)', fontSize: '1.4rem' }}>Conservation & Vos droits</h2>
                    <p>Vos données relatives à votre compte ou à vos achats sont conservées le temps de l'exécution du service, et archivées uniquement à des fins légales, administratives et comptables.</p>
                    <p>
                        Conformément à la Réglementation Générale sur la Protection des Données (RGPD), vous disposez du droit :
                        <strong> d'accès, de suppression, de portabilité et de modification</strong> de vos données.
                        Pour exercer ce droit ou si vous avez la moindre question, vous pouvez contacter notre responsable à l'adresse suivante : <strong>{settings.email}</strong>.
                    </p>
                </section>
            </div>
        </div>
    );
};

export default Privacy;
